import { MessageBusEvents } from 'common/common/constants/message-bus-events';
import { WorkItemStateHandler } from 'shared/services/workitem-state-handler/workitem-state-handler.service';
import { RxEmitter } from 'common/rxjs/rx-emitter';
import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-work-item-lane',
  templateUrl: './work-item-lane.component.html',
  styleUrls: ['./work-item-lane.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WorkItemLaneComponent {
  @Input()
  public workItem;

  @Output()
  activateClick: EventEmitter<void> = new EventEmitter();

  constructor(private WorkItemStateHandler: WorkItemStateHandler, private RxEmitter: RxEmitter) { }

  public setFocus(): void {
    this.RxEmitter.send(MessageBusEvents.SetDefaultFocusInLane, this.workItem.id);
  }

  public isFocused(): boolean {
    return this.WorkItemStateHandler.isFocused(this.workItem.id);
  }

  public onActivateClick(): void {
    this.activateClick.emit();
  }
}
